/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowLeftFromBracket: {
  name: 'arrow-left-from-bracket';
  data: string;
} = {
  name: 'arrow-left-from-bracket',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 4a1 1 0 1 0 0 2h1v12h-1a1 1 0 1 0 0 2h1a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1ZM8.8 8.6a1 1 0 1 0-1.6-1.2l-3 4a1 1 0 0 0 0 1.2l3 4a1 1 0 1 0 1.6-1.2L7 13h8a1 1 0 1 0 0-2H7l1.8-2.4Z" fill="currentColor"/></svg>`,
};
